import { Injectable } from '@angular/core';
import { RequestModel } from './request-model.model';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {
  requests: RequestModel[] = [];

  constructor() {}

  addToCart(singleRequest: RequestModel) {
    this.requests.push(singleRequest);
  }

  getCart() {
    return this.requests;
  }

  getSingleRequest(index: number): RequestModel {
    return this.requests[index];
  }

  clearCart() {
    this.requests.splice(0, this.requests.length);
  }

  removeSingleRequest(index: number) {
    this.requests.splice(index, 1);
  }

  getLength() {
    return this.requests.length;
  }

  duplicate(index: number) {
    return _.cloneDeep(this.requests[index]);
  }

  addDocument(index: number, file: File) {
    this.requests[index].doc = file;
  }

  getDocument(index: number) {
    return this.requests[index].doc;
  }

  removeDocument(index: number) {
    this.requests[index].doc = null;
  }

  editDocument(index: number, request: RequestModel) {
    this.requests[index].doc = request.doc;
  }

  editRequest(index: number, request: RequestModel) {
    this.requests[index] = request;
  }
}
